import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

// If baseURL already includes "/api", don't double-prefix request URLs.
api.interceptors.request.use((config) => {
  const base = config.baseURL || '';
  const url = config.url || '';
  if (typeof base === 'string' && base.replace(/\/+$/, '').endsWith('/api') && typeof url === 'string' && url.startsWith('/api/')) {
    config.url = url.replace(/^\/api/, '');
  }
  return config;
});

// automatic multipart handling: remove content-type if FormData
api.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  return config;
});

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('wd_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-logout on 401 (skip redirect for login endpoint itself)
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const isLoginRequest = err.config?.url?.includes('/auth/login');
    if (err.response?.status === 401 && !isLoginRequest) {
      localStorage.removeItem('wd_token');
      localStorage.removeItem('wd_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
